export const showPaperSetter = [
  //   {
  //     title: 'Paper Request Name',
  //     dataIndex: 'Paper Request Name',
  //     key: 'Paper Request Name',
  //   },
  { title: 'Paper Request', dataIndex: 'Paper Request', key: 'Paper Request' },
  { title: 'Paper Created', dataIndex: 'Paper Created', key: 'Paper Created' },
  { title: 'Paper Pending', dataIndex: 'Paper Pending', key: 'Paper Pending' },
  {
    title: 'Paper For Approval',
    dataIndex: 'Paper For Approval',
    key: 'Paper For Approval',
  },
  { title: 'Paper Approved', dataIndex: 'Paper Approved', key: 'Paper Approved' },
]

export const showPaperApprover = [
  {
    title: 'Paper Request',
    dataIndex: 'Paper Request',
    key: 'Paper Request',
  },
  { title: 'Paper For Approval', dataIndex: 'Paper For Approval', key: 'Paper For Approval' },
  { title: 'Paper Approved', dataIndex: 'Paper Approved', key: 'Paper Approved' },
]

export const showProductManager = [
  {
    title: 'Paper Requests Created',
    dataIndex: 'Paper Requests Created',
    key: 'Paper Requests Created',
  },
  { title: 'Paper Template', dataIndex: 'Paper Template', key: 'Paper Template' },
  { title: 'Test Track', dataIndex: 'Test Track', key: 'Test Track' },
  { title: 'Product', dataIndex: 'Product', key: 'Product' },
  { title: 'Test Event', dataIndex: 'Test Event', key: 'Test Event' },
]

// export const showDeliverManager = [
//   { title: 'Evaluations Assigned', dataIndex: 'Evaluations Assigned', key: 'Evaluations Assigned' },
//   { title: 'Evaluations finished', dataIndex: 'Evaluations finished', key: 'Evaluations finished' },
// ]

export const showProductManagerTestTrack = [
  {
    title: 'Test Track Created',
    dataIndex: 'Test Track Created',
    key: 'Test Track Created',
  },
  {
    title: 'Paper Templates Associated',
    dataIndex: 'Paper Templates Associated',
    key: 'Paper Templates Associated',
  },
  {
    title: 'Papers Associated',
    dataIndex: 'Papers Associated',
    key: 'Papers Associated',
  },
]

export const showProductManagerPaperTemplates = [
  {
    title: 'Paper Tenplate Created',
    dataIndex: 'Paper Tenplate Created',
    key: 'Paper Tenplate Created',
  },
  {
    title: 'No of Subsection Associated',
    dataIndex: 'No of Subsection Associated',
    key: 'No of Subsection Associated',
  },
  {
    title: 'Papers Associated',
    dataIndex: 'Papers Associated',
    key: 'Papers Associated',
  },
]

export const showProductManagerProducts = [
  {
    title: 'Product Created',
    dataIndex: 'Product Created',
    key: 'Product Created',
  },
  {
    title: 'Test Events Associated',
    dataIndex: 'Test Events Associated',
    key: 'Test Events Associated',
  },
  {
    title: 'Paper Templates Associated',
    dataIndex: 'Paper Templates Associated',
    key: 'Paper Templates Associated',
  },
  {
    title: 'Papers Associated',
    dataIndex: 'Papers Associated',
    key: 'Papers Associated',
  },
]
